export const allowSound = () => {
  return localStorage.getItem("allowSound") === "no" ? false : true;
};
